/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Volume_DistanceInputs */

const en_ui_volume_distance = /** @type {(inputs: Ui_Volume_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance`)
};

const de_ui_volume_distance = /** @type {(inputs: Ui_Volume_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distanz`)
};

/**
* | output |
* | --- |
* | "Distance" |
*
* @param {Ui_Volume_DistanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_volume_distance = /** @type {((inputs?: Ui_Volume_DistanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Volume_DistanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_volume_distance(inputs)
	return de_ui_volume_distance(inputs)
});